export const _Q_qToken = `X2X2X_X2X2X`;
export const _Q_qToken2 = `XXX_XXX2`;
export const _Q_qTokenV = `VXVX_XVXV`;
export const _Q_qTokenPage = `PXPX_PXPX`;
export const maxPageSize = 1000;

export const _Q_dashboards = `
dashboards{
  totalSystems
  totalHosts
  hostsByOs {
    count
    version
  }
  hostsByJava {
    count
    version
  }
  totalApplications
  totalInstalledPackages
  candidates
  totalEol
  totalHostsWithVulnerabilities
}
`;

export const _Q_getHostsInstalledPackagesAgg = `
  getHostsInstalledPackagesAgg{
    machineId
    totalInstalled
    eolPackages
    candidatePackages
  }
`;

export const _Q_getScannedByDayAndOs = `
  getScannedByDayAndOs{
    collectionDay,
    hosts{
      cnt,
      osName
    }        
  }
`;

export const _Q_getIpNotScanned = `
        getIpNotScanned{
            ip
            numberOfConnections
        }
`;

export const _Q_systemsDiscovery = `
{
  systems(page: 1, pageSize: ${maxPageSize})  {
  systems {
    id
    collectedAt
    version
    isVirtual
    uptime
    boottime
    hostName
    cloudType
    instanceId
    nics {
      name
      ips {
        ip
        isIpV6
      }
      macAddress
    }
    disks {
      diskType
      name
      mountPoint
      totalSpace
      availableSpace
      isRemovable
      fileSystemType
    }
    processor {
      frequency
      vendorId
      manufacturer
      cpuUsage
      cores {
        name
        frequency
        cpuUsage
      }
    }
    memory {
      timestamp
      available
      used
      total
      free
      freeSwap
      usedSwap
      totalSwap
    }
    users {
      uid
      gid
      name
      groups
    }
    gpus {
      name
      vendor
      capacity
    }
    bios{
      biosInfo{
        vendor
        version
        releaseDate
      }
      systemInfo{
        manufacturer
        productName
        version
        serialNumber
        wakeupType
        skuNumber
        family
      }
      baseBoardInfo{
        manufacturer
        product
        version
        serialNumber
        assetTag
      }
    }
  }
}}
`;

export const _Q_hostsDiscovery = `
{
  hosts(page: 1, pageSize: ${maxPageSize}) {
    hosts{
      timestamp
      machineId
      name
      description
      owner
      tags
      protocolId
      scannedIp
      os {
        name
        version
        kernelName
        kernelVersion
        windowsLicenseInfo{
          name
          description
          activationId
          applicationId
          extendedPid
          productKeyChannel
          installationId
          useLicenseUrl
          validationUrl
          partialProductKey
          licenseStatus
          timebasedActivationExpiration
          remainingWindowsRearmCount
          remainingSkuRearmCount
          trustedTime
        }
        windowsInstalledUpdates {
          caption
          csName
          description
          fixComments
          hotFixId
          installDate
          installedBy
          installedOn
          name
          servicePackInEffect
          status
        }
        windowsDetails {
          edition
          buildNumber
          systemDirectory
          installDate
          lastBootUpTime
          maxNumberOfProcesses
          maxProcessMemorySize
          numberOfProcesses
          osArchitecture
        }
        isEol
        eolDate
        latestVersion
      }
      jvm {
        name
        version
        javaHome
        isEol
        eolDate
        latestVersion
      }
      fs {
        name
        mountPoint
        fileSystemType
      }
    } 
  }
}
`;

export const _Q_getHostsWithVulnerabilities = `
    getHostsWithVulnerabilities{
      machineId
      vulnerabilities {
        version
        packageName
        vulnerability
      }
    }
`;

export const _Q_getApplicationGraph = `
query getApplicationGraph${_Q_qToken2}{
  getApplicationGraph(machineId: "${_Q_qToken}"){
    apps {
      id
      applicationTemplateId
      machineId
      name
      version
      machineEntityVersion
      binFolder
      description
      collectedDataPath
      cmdLine
      properties
      protocolId
      dockerImageUrl
    }
    hosts {
      collectedAt
      machineId
      name
      description
    }
    relations {
      id
      machineId
      connectionState
      appId
      localIp
      localPort
      remoteIp
      remotePort
      remoteAppId
    }
    appToHost {
      appId
      hostId
    }
  }
}
`

export const _Q_installedPackages = `
query installedPackages${_Q_qToken2}{
  installedPackages(machineId: "${_Q_qToken}"){
    name
    version
    candidateVersion
    isEol
    eolDate
    vulnerabilities
    vendor
  }
}`;


export const _Q_installedPackagesMultiple = `
  installedPackages(machineId: "${_Q_qToken}"){
    name
    version
    candidateVersion
    isEol
    eolDate
    vulnerabilities
    vendor
  }
`;

export const _Q_getAllContainers = `
getAllContainers{
    id
    containerType
    items
    entityVersion
    createdAt
    systemId
}`;

export const _Q_getAppConnections = `
  {
    getAppConnections {
    id
    machineId
    appId
    localIp
    localPort
    remoteIp
    remotePort
    remoteAppId
  }
}
`;

export const _Q_getResolvedAppConnections = _Q_getAppConnections.replace("getAppConnections", "getResolvedAppConnections");


export const _Q_getAllVersionTimePaged = `
query getVersionTime($page: Int, $pageSize: Int) {
  systems(page: $page, pageSize: $pageSize)  {
     systems{
      id
      version
     }
     pageInfo {
      totalPages
      currentPage
    }
  }

  hosts(page: $page, pageSize: $pageSize) {
      hosts{
        name
        machineId
        timestamp
      }
      pageInfo {
       totalPages
       currentPage
     }
    }
}`;



export const _Q_VersionTime = {
  query: `${_Q_getAllVersionTimePaged}`,
  name: "versionTime"
}



export const _Q_getAllApplicationsPaged = `
getCurrentApplications(page: $page, pageSize: $pageSize) {
    apps {
        id
        applicationTemplateId
        machineId
        name
        version
        machineEntityVersion
        binFolder
        description
        collectedDataPath
        cmdLine
        properties
        dockerImageUrl
        connectors {
            connectorType
            name
            values
        }
        protocolId
        scannedIp
        tags
        extracted
        downloadUrl
        extractedAt
    }
    pageInfo {
        totalPages
        currentPage
    }
}
`;

export const _Q_getAllApplicationComponents = `
getApplicationComponents {
  id
  name
  description
  repositoryUrl
  dockerImageUrl
  repositoryType
  token
  projectId
  applicationInstanceId
  downloadUrl
  uploadedAt
  createdAt
}
`

export const _Q_MergedQueryApps = {
  query: `${_Q_getAllApplicationsPaged}`,
  mergeWithQuery: `${_Q_getAllApplicationComponents}`,
  name: "getCurrentApplicationsPaged",
  mergeName:"getAllApplicationComponents"
}


export const _Q_getAllApplicationsPagedCOMP = `
  getCurrentApplications(page: $page, pageSize: $pageSize) {
    apps {
      id
      applicationTemplateId
      machineId
      name
      version
      machineEntityVersion
      binFolder
      description
      collectedDataPath
      cmdLine
      properties
      dockerImageUrl
      connectors {
        connectorType
        name
        values
      }
      protocolId
      scannedIp
      tags
      extracted
      downloadUrl
      extractedAt
    }
    pageInfo {
      totalPages
      currentPage
    }
  }
  getApplicationComponents {
    id
    name
    description
    repositoryUrl
    dockerImageUrl
    repositoryType
    projectId
    applicationInstanceId
    downloadUrl
    uploadedAt
    createdAt
  }
`;

export const _Q_getAllApplications = `
  getCurrentApplications(page: 1, pageSize: ${maxPageSize}) {
    apps {
      id
      applicationTemplateId
      machineId
      name
      version
      machineEntityVersion
      binFolder
      description
      collectedDataPath
      cmdLine
      dockerImageUrl
      properties
      connectors {
        connectorType
        name
        values
      }
      scannedIp
      protocolId
      tags
          extracted
          extractedAt
    }
    pageInfo {
      totalPages
      currentPage
    }
  }
  getApplicationComponents {
    id
    name
    description
    repositoryUrl
    dockerImageUrl
    repositoryType
    projectId
    applicationInstanceId
    downloadUrl
    uploadedAt
    createdAt
  }
`;

export const _Q_getCurrentApplicationsForMachine = _Q_getAllApplications.replace("getCurrentApplications {", `getCurrentApplicationsForMachine(machineId: "${_Q_qToken}") {`);
export const _Q_getCurrentApplicationsForMachineShort = _Q_getCurrentApplicationsForMachine.replace(`query getCurrentApplications_${_Q_qToken2}{`, "").replace("cmdLine", "").slice(0, -1);

export const _Q_systemV = `
query systemData_${_Q_qToken2}_v${_Q_qTokenV}{
  getSystemByVersion(machineId: "${_Q_qToken}", version: ${_Q_qTokenV} ){
    id
    collectedAt
    version
    isVirtual
    uptime
    boottime
    hostName
    cloudType
    instanceId
    nics {
      name
      ips {
        ip
        isIpV6
      }
      macAddress
    }
    disks {
      diskType
      name
      mountPoint
      totalSpace
      availableSpace
      isRemovable
      fileSystemType
    }
    processor {
      frequency
      vendorId
      manufacturer
      cpuUsage
      cores {
        name
        frequency
        cpuUsage
      }
    }
    memory {
      timestamp
      available
      used
      total
      free
      freeSwap
      usedSwap
      totalSwap
    }
    users {
      uid
      gid
      name
      groups
    }
    gpus {
      name
      vendor
      capacity
    }
    bios{
      biosInfo{
        vendor
        version
        releaseDate
      }
      systemInfo{
        manufacturer
        productName
        version
        serialNumber
        wakeupType
        skuNumber
        family
      }
      baseBoardInfo{
        manufacturer
        product
        version
        serialNumber
        assetTag
      }
    }

  }
}
`;

export const _Q_system = `
query systemData_${_Q_qToken2}{
  system(machineId: "${_Q_qToken}"){
    id
    collectedAt
    version
    isVirtual
    uptime
    boottime
    hostName
    cloudType
    instanceId
    nics {
      name
      ips {
        ip
        isIpV6
      }
      macAddress
    }
    disks {
      diskType
      name
      mountPoint
      totalSpace
      availableSpace
      isRemovable
      fileSystemType
    }
    processor {
      frequency
      vendorId
      manufacturer
      cpuUsage
      cores {
        name
        frequency
        cpuUsage
      }
    }
    memory {
      timestamp
      available
      used
      total
      free
      freeSwap
      usedSwap
      totalSwap
    }
    users {
      uid
      gid
      name
      groups
    }
    gpus {
      name
      vendor
      capacity
    }
    bios{
      biosInfo{
        vendor
        version
        releaseDate
      }
      systemInfo{
        manufacturer
        productName
        version
        serialNumber
        wakeupType
        skuNumber
        family
      }
      baseBoardInfo{
        manufacturer
        product
        version
        serialNumber
        assetTag
      }
    }
  }
}
`;

export const _Q_versionTime = `
  query versionTime{
    systems(page: 1, pageSize: ${maxPageSize}){systems{ id, version }}
    hosts(page: 1, pageSize: ${maxPageSize}){ hosts{name, machineId, timestamp }} 
  }
`;

export const _Q_hostV = `
query hostData_${_Q_qToken2}_v${_Q_qTokenV}{
  hostByVersion(machineId: "${_Q_qToken}", version: ${_Q_qTokenV}){
      timestamp
      machineId
      name
      description
      owner
      tags
      protocolId
      scannedIp
      os {
        name
        version
        kernelName
        kernelVersion
        windowsLicenseInfo{
          name
          description
          activationId
          applicationId
          extendedPid
          productKeyChannel
          installationId
          useLicenseUrl
          validationUrl
          partialProductKey
          licenseStatus
          timebasedActivationExpiration
          remainingWindowsRearmCount
          remainingSkuRearmCount
          trustedTime
        }    
        windowsInstalledUpdates {
          caption
          csName
          description
          fixComments
          hotFixId
          installDate
          installedBy
          installedOn
          name
          servicePackInEffect
          status
        }
        windowsDetails {
          edition
          buildNumber
          systemDirectory
          installDate
          lastBootUpTime
          maxNumberOfProcesses
          maxProcessMemorySize
          numberOfProcesses
          osArchitecture
        }
        isEol
        eolDate
        latestVersion
      }
      jvm {
        name
        version
        javaHome
        isEol
        eolDate
        latestVersion
      }
      fs {
        name
        mountPoint
        fileSystemType
      }
    } 
}
`;

export const _Q_host = `
query hostData_${_Q_qToken2}{
  host(machineId: "${_Q_qToken}"){
      timestamp
      machineId
      name
      description
      owner
      tags
      os {
        name
        version
        kernelName
        kernelVersion
        windowsLicenseInfo{
          name
          description
          activationId
          applicationId
          extendedPid
          productKeyChannel
          installationId
          useLicenseUrl
          validationUrl
          partialProductKey
          licenseStatus
          timebasedActivationExpiration
          remainingWindowsRearmCount
          remainingSkuRearmCount
          trustedTime
        }    
        windowsInstalledUpdates {
          caption
          csName
          description
          fixComments
          hotFixId
          installDate
          installedBy
          installedOn
          name
          servicePackInEffect
          status
        }
        windowsDetails {
          edition
          buildNumber
          systemDirectory
          installDate
          lastBootUpTime
          maxNumberOfProcesses
          maxProcessMemorySize
          numberOfProcesses
          osArchitecture
        }
        isEol
        eolDate
        latestVersion
      }
      jvm {
        name
        version
        javaHome
        isEol
        eolDate
        latestVersion
      }
      fs {
        name
        mountPoint
        fileSystemType
      }
    } 
}
`;

export const _Q_queryProcesses = `
query qProcesses_${_Q_qToken2}{
  processesByVersion(machineId: "${_Q_qToken}", version: ${_Q_qTokenV}) {
    pid
    parentPid
    name
    cwd
    userId
    groupId
    cmdLine
    exePath
    rootPath
    status
    envVars
    cpuUsage
    memoryUsage
    virtualMemoryUsage
    diskUsage {
      totalWrittenBytes
      writtenBytes
      totalReadBytes
      readBytes
    }
    startTime
    runningTime
  }
}
`

export const _Q_queryConnections = `
query qconnections_${_Q_qToken2}{
  connectionsByVersion(machineId: "${_Q_qToken}", version: ${_Q_qTokenV}) {
    address {
      localAddr
      localPort
      remoteAddr
      remotePort
      state
      protocol
    }
    associatedPids
  }
}
`


export const _Q_queryFields =`
query queryFields {
  __type(name: "${_Q_qToken}") {
      ...FullType
  }
} 

fragment FullType on __Type {
    name
    fields(includeDeprecated: true) {
      name
      type {
        ...TypeRef
      }
    }
  }
  
  fragment TypeRef on __Type {
    kind
    name
    ofType {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
        }
      }
    }
  }

`;

export const userTokenID = "XXX_USER_ID_XXX";

export const sub_query_system = `
  subscription Subscribe {
    subscribe(name: "system") {
      name
      data
    }
  }
`;

export const sub_query_user = `
  subscription Subscribe {
    subscribe(name: "${userTokenID}") {
      name
      data
    }
  }
`;


//connection_state
export const _Q_applicationsGraph = `
query applicationsGraph{
    applicationsGraph {
      apps {
        id
        name
        version
        machineId
        description
      }
      connections {
        id
        machineId
        appId
        localIp
        localPort
        remoteIp
        remotePort
        remoteAppId
        projectId
        connectionState
      }
    }
}
`;

export const _Q_hostsGraph = `
query hostsGraph{
  hostsGraph {
      hosts {
        collectedAt
        machineId
        name
        description
        isUnknownHost
      }
      connections {
        source
        target
        connections{
        localAddr
        localPort
        remoteAddr
        remotePort
        state
        protocol
      }
    }
  }
}
`;

export const _Q_vulnerabilityBlast = `
query vulnerabilityBlast
  {
    vulnerabilities {
      vulnerability {
        cve
        description
        vendor
        package
        version
        severity
      }
      affectedHosts
    }
  }

`;

export const _Q_getEnrichmentResults = `
  query GetEnrichmentResults($page: Int, $pageSize: Int) {
    getEnrichmentResults(page: $page, pageSize: $pageSize) {
      results { id applicationId discoveryId appName hostname status correlationScore enrichedAt createdAt updatedAt record }
      pageInfo { totalPages currentPage }
    }
  }
`;

export const _Q = {
  _Q_qToken,
  _Q_qToken2,
  _Q_qTokenV,
  _Q_dashboards,
  _Q_queryProcesses,
  _Q_queryConnections,
  _Q_installedPackages,
  _Q_getAllContainers,
  _Q_getScannedByDayAndOs,
  _Q_getIpNotScanned,
  _Q_systemsDiscovery,
  _Q_hostsDiscovery,
  _Q_getHostsWithVulnerabilities,
  _Q_getHostsInstalledPackagesAgg,
  _Q_getAppConnections,
  _Q_getResolvedAppConnections,
  _Q_getAllApplications,
  _Q_getApplicationGraph,
  _Q_getCurrentApplicationsForMachine,
  _Q_getCurrentApplicationsForMachineShort,
  _Q_host,
  _Q_hostV,
  _Q_system,
  _Q_systemV,
  _Q_versionTime,
  _Q_applicationsGraph,
  _Q_hostsGraph,
  _Q_vulnerabilityBlast,
  _Q_getEnrichmentResults
}